export default "__VITE_ASSET__DLQA$hlw__"